import { createIcon } from "@chakra-ui/icons";

const HorizontalRule = createIcon({
  displayName: "HorizontalRule",
  viewBox: "0 0 640 512",
  path: (
    <path
      d="M640 239.87v31.26A15.88 15.88 0 0 1 624.14 287H15.87A15.88 15.88 0 0 1 0 271.13v-31.26A15.88 15.88 0 0 1 15.87 224h608.27A15.88 15.88 0 0 1 640 239.87z"
      fill="currentColor"
    />
  ),
});
export default HorizontalRule;
